import AXIOS from '@/utils/$axios';

// 项目审核详情
export const queryProjectAudit = payload => {
  return AXIOS.post(
    '/space/project/drawingTeam/plan/check/project-detail',
    payload
  );
};

// 项目审核
export const checkAudit = payload => {
  return AXIOS.post('/space/project/drawingTeam/plan/check/project', payload);
};

// 项目审核短信通知
export const informAudit = payload => {
  return AXIOS.post(
    '/space/project/drawingTeam/plan/check/click-project',
    payload
  );
};

// 邀请项目/团队成员
export const inviteMembers = (params, type) => {
  return AXIOS.get(
    ['/space/project/common/member-save', '/space/team/member/member-save'][
    type - 1
    ],
    { params }
  );
};

// 获取用户在当前项目中的权限
export const getProjectPermission = payload => {
  return AXIOS.post('/space/project/common/project-power', payload);
};

// 项目成员列表
export const queryMembers = payload => {
  return AXIOS.post('/space/project/common/member-list', payload);
};

// 项目成员的添加，删除，编辑，获取详情
export const modifyInfo = payload => {
  return AXIOS.post('/space/project/common/member-save', payload);
};

// 团队成员列表/space/team/member/list
export const queryTeamMembers = payload =>
  AXIOS.post('/space/team/member/list', payload);

// 队员权限列表
export const getRoleList = payload =>
  AXIOS.post('/space/team/power/list', payload);

// 添加成员获取分享链接
export const inviteMember = payload => {
  return AXIOS.post('/space/project/common/share', payload);
};

// 所有权限信息
export const getAllRole = payload =>
  AXIOS.post('/space/team/power/all-power', payload);

// 附件分享
export const shareAdjunct = payload =>
  AXIOS.post('/space/project/common/adjunct-share', payload);

// 附件分享
export const queryStatusPlans = payload =>
  AXIOS.post('/space/project/project/project-plan-status', payload);

// 项目详情
export const queryProductContent = payload =>
  AXIOS.post(`/space/project/common/content`, payload);

// 根据省市区，查询小区
export const queryEstate = payload => {
  return AXIOS.post('/space/common/district-hose', payload);
};

// 保存项目（创建和编辑）
export const effectProduct = payload => {
  return AXIOS.post('/space/project/project/save', payload);
};

// 项目中角色列表
export const getRoles = payload =>
  AXIOS.post('/space/team/power/list-project-role', payload);


  // 退付款添加
export const addAccount = payload => {
  return AXIOS.post('/space/project/fund/add', payload);
};

// 修改退付款
export const putAccount = payload => {
  return AXIOS.post('/space/project/fund/update', payload);
};

// 退付款列表
export const getAccounts = payload => {
  return AXIOS.post('/space/project/fund/list', payload);
};

// 退付款删除
export const delAccount = payload => {
  return AXIOS.post('/space/project/fund/delete', payload);
};

// 退付款详情
export const getAccountDetail = payload => {
  return AXIOS.post('/space/project/fund/info', payload);
}
// 查询设置指引状态
export const getUserGuidance = params => {
  return AXIOS.get('/space/user/guidance', { params });
};

export const getMockCreateProject = payload => {
  return AXIOS.post('/space/mock/create-project', payload);
};
